import React from "react";
import { Span, Button } from "@icg360/design-system";

import { formatAddress } from "../policy-view/policy-modals/mortgagee-change/utils";

import { Wrapper, Container, MortgageeName, MortgageeAddress } from "./styles";

import type { Mortgagee } from "./mortgagee-search";

interface MortgageeSearchDisplay {
  mortgagee?: Mortgagee;
  value?: string;
  onChange?: () => void;
  onClear: () => void;
}

export const MortgageeSearchDisplay = ({
  mortgagee,
  value: rexValue,
  onChange,
  onClear
}: MortgageeSearchDisplay) => {
  const splitIndex = rexValue?.indexOf(", ");
  const mortgageeName = rexValue?.slice(0, splitIndex) || mortgagee.Mortgagee;
  const mortgageeAddress =
    rexValue?.slice(splitIndex + 1) || formatAddress(mortgagee);

  const handleClear = () => {
    // this comes from Rex input and is needed to update the form
    if (onChange) {
      onChange();
    }

    onClear();
  };

  return (
    <Wrapper data-bdd="mortgagee-display">
      <Container>
        <MortgageeName>
          <img src="../../../assets/svg/mortgagee-icon.svg" />
          {mortgageeName}
        </MortgageeName>
        <MortgageeAddress>
          <Span size="sm">{mortgageeAddress}</Span>
        </MortgageeAddress>
      </Container>
      <Button
        appearance="neutral"
        data-bdd="mortgagee-display-clear"
        icon="Close"
        size="xs"
        onPress={handleClear}
      />
    </Wrapper>
  );
};
